import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledPageHeading = styled.section`
  background-color: #414141;
  margin: 0px;
  padding: 20px 0px;
  text-align: center;
  color: #ffffff;
`;

const StyledPageBody = styled.section`
  width: calc(100% - 40px);
  max-width: 1500px;
  margin: 0 auto;
  padding: 20px;
`;

const StyledPara = styled.p`
  font-size: 14px;
  font-weight: normal;
  color: #000000;
  text-decoration: none;
  margin: 0px;
  padding: 0px;
  line-height: 24px;
  text-align: center;
`;

const StyledTextHighlight = styled.span`
  font-size: 14px;
  font-weight: normal;
  color: #0095ff;
  text-decoration: none;
  margin: 0px;
  padding: 0px;
`;

const StyledAuthLinks = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledLink = styled(Link)`
  font-size: 14px;
  font-weight: normal;
  color: ${({ theme: { colors } }) => colors.primaryColor || `#3049f8`};
  text-decoration: none;
  margin: 0px;
  padding: 0px;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledButtonAsLink = styled.button`
  border-width: 0px;
  background-color: transparent;
  cursor: pointer;
  outline: 0;
  font-size: 14px;
  font-weight: normal;
  color: ${({ theme: { colors } }) => colors.primaryColor || `#3049f8`};
  text-decoration: none;
  margin: 0px;
  padding: 0px;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledAuthFooterLinkText = styled.p`
  font-size: 14px;
  font-weight: normal;
  color: #767676;
  text-decoration: none;
  margin: 0px;
  padding: 0px;
`;

const StyledAuthContent = styled.section`
  width: 100%;
  max-width: 500px;
  height: auto;
  position: relative;
  margin: 0 auto;
  padding: 30px;
`;

const StyledFormContainer = styled.section`
  width: 100%;
  max-width: 500px;
  flex: 1;
`;

const StyledAccountContainer = styled.section`
  width: 100%;
  height: auto;
  min-height: 600px;
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
`;

const StyledAccountLinksContainer = styled.section`
  background-color: #d8d8d8;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
  a {
    font-size: 14px;
    font-weight: normal;
    text-decoration: none;
    display: block;
    margin: 0px;
    padding: 25px 30px;
    width: 200px;
    max-width: 200px;
    color: #000000;
    &:first-child {
      border-top-left-radius: inherit;
    }
    &:hover,
    &.active {
      background-color: #ffffff;
    }
  }
`;

const StyledAccountSection = styled.section`
  flex: 1;
  padding: 50px;
  position: relative;
`;

const StyledAddressesContainer = styled.section`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`;

const StyledAddButton = styled.button`
  border: 3px dashed #d8d8d8;
  font-size: 22px;
  font-weight: bold;
  margin: 0px;
  padding: 20px;
  background-color: transparent;
  outline: 0px;
  cursor: pointer;
  border-radius: 10px;
  &:hover {
    background-color: #f1f1f1;
  }
`;

const StyledAddAddressContainer = styled.section`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  margin: 0 auto;
  padding: 20px;
`;

const StyledMapContainer = styled.section`
  width: 100%;
  min-width: 400px;
  height: auto;
  min-height: 400px;
`;

const StyledAddressContainer = styled.section`
  width: 100%;
  min-width: 500px;
`;

const StyledGrid = styled.section`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  fieldset {
    flex: 1;
  }
`;

const StyledContactMapContainer = styled.section`
  width: 100%;
  height: auto;
  iframe {
    width: 100%;
    height: 400px;
    max-height: 500px;
    border: 1px solid #c1c1c1;
    border-radius: 10px;
    box-shadow: 5px 5px 15px -10px #000000;
  }
`;

const StyledAddressMapContainer = styled.section``;

const StyledContactFormContainer = styled.section`
  flex: 1;
`;

const StyledContactAddressContainer = styled.section`
  width: 100%;
  height: auto;
  margin: 30px 0px 0px 0px;
  padding: 0px;
`;

const StyledSection = styled.section``;

const StyledContactPageContainer = styled.section`
  display: flex;
  flex-direction: row;
  column-gap: 100px;
  padding: 50px;
`;

const StyledContactGrid = styled.section`
  display: flex;
  column-gap: 20px;
  align-items: center;
  margin: 0px 0px 20px 0px;
  svg {
    font-size: 20px;
    color: #ff9800;
  }
  h2 {
    font-size: 24px;
    font-weight: 500;
    color: #000000;
    margin: 0px;
    padding: 0px;
  }
  address {
    font-size: 14px;
    font-style: normal;
    color: #434343;
    margin: 0px;
    padding: 0px;
  }
  p {
    font-size: 14px;
    font-style: normal;
    color: #434343;
    margin: 0px;
    padding: 0px;
  }
`;

export {
  StyledPageHeading,
  StyledPageBody,
  StyledPara,
  StyledTextHighlight,
  StyledAuthLinks,
  StyledLink,
  StyledButtonAsLink,
  StyledAuthFooterLinkText,
  StyledAuthContent,
  StyledFormContainer,
  StyledAccountContainer,
  StyledAccountLinksContainer,
  StyledAccountSection,
  StyledAddressesContainer,
  StyledAddButton,
  StyledAddAddressContainer,
  StyledMapContainer,
  StyledAddressContainer,
  StyledGrid,
  StyledContactPageContainer,
  StyledContactMapContainer,
  StyledAddressMapContainer,
  StyledContactFormContainer,
  StyledContactAddressContainer,
  StyledSection,
  StyledContactGrid,
};
